import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { toApiError } from "@/shared/utils/general";
import { createMigrationParameter } from "@/shared/actions/campanas/migracion.actions";
import { queryClient } from "@/shared/query-client/query-client";
export const useCreateMigrationParameter = () => {
  const mutation = useMutation({
    mutationFn: createMigrationParameter,
    onSuccess: () => {
  toast.success("Parámetro guardado correctamente");

  queryClient.invalidateQueries({
    queryKey: ["campaign-config-summary"],
  });
  },
    onError: (error) => {
      const data = toApiError(error);
      toast.error(data.message);
    },
  });

  return {
    saveParameter: mutation.mutate,
    loading: mutation.isPending,
  };
};